// extracted by mini-css-extract-plugin
export default {"biFrameWrap":"style_biFrameWrap__tQ20U","biFrame":"style_biFrame__4I1rC","biBrandCover":"style_biBrandCover__LJX0Z"};